/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react'

import { ApiClient } from '../../api/core'
import { invariant } from '../../utils'
import { getApiContext } from './ApiContext'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export interface ApiProviderProps<T> {
  client: ApiClient
  children: React.ReactNode | React.ReactNode[] | null
}

export const ApiProvider: React.FC<ApiProviderProps<any>> = ({ client, children }) => {
  const ApiContext = getApiContext()
  return (
    <ApiContext.Consumer>
      {(context: any = {}) => {
        if (client && context.client !== client) {
          context = Object.assign({}, context, { client })
        }

        invariant(
          context.client,
          'ApiProvider was not passed a client instance. Make ' + 'sure you pass in your client via the "client" prop.',
        )

        return <ApiContext.Provider value={context}>{children}</ApiContext.Provider>
      }}
    </ApiContext.Consumer>
  )
}
